// extracted by mini-css-extract-plugin
export default {"SliderViewBlock":"SliderView_SliderViewBlock__UwWfI"};